import { render, staticRenderFns } from "./NotesEditor.vue?vue&type=template&id=02c6e3e9&scoped=true"
import script from "./NotesEditor.vue?vue&type=script&lang=js"
export * from "./NotesEditor.vue?vue&type=script&lang=js"
import style0 from "./NotesEditor.vue?vue&type=style&index=0&id=02c6e3e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c6e3e9",
  null
  
)

export default component.exports